import React, { FunctionComponent } from 'react'

import { Flex } from '@theme-ui/components'
import { Link, useLocation } from 'react-router-dom'

import styled from 'styled-components'

import { baseColors, makeTransition } from '@fairhq/common'

import { Dot } from './assets/icons/Dot'
import { IReportsSidebarSubMenuItem } from './types/reportsSidebarSubMenuItem'

const MenuLink = styled(Link)`
  cursor: pointer;
  flex-basis: 100%;

  &:hover {
    text-decoration: none;
  }
`

export const SubMenuItem: FunctionComponent<IReportsSidebarSubMenuItem> = ({
  text,
  url,
  onClick,
}) => {
  const location = useLocation()

  const active = url ? location.pathname.startsWith(url) : false

  return (
    <MenuLink to={url}>
      <Flex
        variant="text.label"
        sx={{
          cursor: 'pointer',
          position: 'relative',
          pl: '35px',
          minHeight: 42,
          alignItems: 'center',
          color: baseColors.contentInverseContent,
          transition: makeTransition('color'),
          alignIems: 'center',
          gap: '6px',
          '&:hover': { bg: baseColors.statesHoverBackground },
          '&:focus': { bg: baseColors.statesHoverBackground },
        }}
        onClick={onClick}
      >
        <Dot fill={active ? 'currentColor' : 'transparent'} />
        {text}
      </Flex>
    </MenuLink>
  )
}
